import React from 'react';
import styled from 'styled-components';

interface RiskGaugeProps {
  level: 'low' | 'moderate' | 'high';
}

const GaugeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const GaugeVisual = styled.div`
  position: relative;
  width: 200px;
  height: 100px;
  margin-bottom: 20px;
`;

const GaugeBackground = styled.div`
  position: absolute;
  width: 200px;
  height: 100px;
  border-top-left-radius: 100px;
  border-top-right-radius: 100px;
  background: linear-gradient(90deg, #4CAF50 0%, #FFB400 50%, #E45858 100%);
  overflow: hidden;
`;

const GaugeNeedle = styled.div<{ rotation: number }>`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform-origin: bottom center;
  transform: translateX(-50%) rotate(${props => props.rotation}deg);
  width: 4px;
  height: 90px;
  background-color: #1A2440;
  z-index: 2;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;
    background-color: #1A2440;
    border-radius: 50%;
  }
`;

const GaugeCenter = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border: 2px solid #1A2440;
  border-radius: 50%;
  z-index: 3;
`;

const RiskLevel = styled.div<{ level: 'low' | 'moderate' | 'high' }>`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  color: ${props => 
    props.level === 'low' 
      ? '#4CAF50' 
      : props.level === 'moderate' 
        ? '#FFB400' 
        : '#E45858'
  };
  text-transform: uppercase;
`;

const RiskGauge: React.FC<RiskGaugeProps> = ({ level }) => {
  // Calculate needle rotation based on risk level
  const getNeedleRotation = () => {
    switch (level) {
      case 'low':
        return -60; // Left side of gauge
      case 'moderate':
        return 0;   // Middle of gauge
      case 'high':
        return 60;  // Right side of gauge
      default:
        return 0;
    }
  };

  return (
    <GaugeContainer>
      <GaugeVisual>
        <GaugeBackground />
        <GaugeNeedle rotation={getNeedleRotation()} />
        <GaugeCenter />
      </GaugeVisual>
      <RiskLevel level={level}>
        {level}
      </RiskLevel>
    </GaugeContainer>
  );
};

export default RiskGauge;
